import alertConstants from '../constants';

function alertFunc(type, message, callback) {
    return dispatch => {
        dispatch({ type, message, callback });
    };
}

const success = (message, callback) => alertFunc(alertConstants.SUCCESS, message, callback);
const error = (message, callback) => alertFunc(alertConstants.ERROR, message, callback);
const warn = (message, callback) => alertFunc(alertConstants.WARN, message, callback);
const info = (message, callback) => alertFunc(alertConstants.INFO, message, callback);

function clear() {
    return { type: alertConstants.CLEAR };
}

export default {
    success,
    warn,
    info,
    error,
    clear
};